import styled from 'styled-components';
import { colors } from '../../constants';

const Row = styled.ul``;
const Item = styled.li``;
const Copyright = styled.p``;

interface IProps {
    className?: string;
}

const BaseFooter = ({ className }: IProps) => (
    <footer className={className}>
        <Row>
            <Item>
                <a href="https://www.grandoptical.nl/home/disclaimer-privacy">
                    Privacy
                </a>
            </Item>
            <Item>
                <a href="https://www.grandoptical.nl/home/algemene-voorwaarden">
                    Algemene voorwaarden
                </a>
            </Item>
        </Row>
        <Copyright>© Copyright GrandOptical.nl</Copyright>
    </footer>
);

export const Footer = styled(BaseFooter)`
    padding: 0 1rem 3.5rem;
    margin-top: 2.5rem;
    background-color: ${colors.black};
    color: ${colors.white};

    ${Row} {
        display: flex;
        flex-flow: row wrap;
        margin: 0 auto;
        justify-content: center;
        max-width: 80%;
    }

    ${Item} {
        display: block;
        flex: 0 0 auto;
        margin: 1.5rem 0.5rem 0;
    }

    a {
        color: ${colors.white};
        font-weight: 700;

        &:hover {
            text-decoration: underline;
        }
    }

    ${Copyright} {
        text-align: center;
        margin-top: 1.5rem;
    }
`;
